import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash';
// Import Hooks
import { useAppSelector } from 'store';
// Import Store
import { selectUserId, selectUserActivePartnerId } from 'store/slices/userData';

window.dataLayer = window.dataLayer || [];

const useGTMPageView = (pageTitle) => {
    const location = useLocation();
    const userId = useAppSelector(selectUserId);
    const partnerId = useAppSelector(selectUserActivePartnerId);

    useEffect(() => {
        window.dataLayer.push({
            event: 'page_view',
            page_path: location.pathname,
            page_title: pageTitle,
            user_id: userId,
            partner_id: partnerId,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

const useGTMEvent = () => {
    const userId = useAppSelector(selectUserId);
    const partnerId = useAppSelector(selectUserActivePartnerId);

    const logEvent = useCallback(
        (eventCategory, eventAction, eventLabel, eventValue?) => {
            // an unmapped event key would push `event: undefined` and fire no GTM trigger
            if (isNil(eventAction)) return;

            window.dataLayer.push({
                event: eventAction,
                event_category: eventCategory,
                event_label: eventLabel,
                ...(eventValue !== undefined && { value: eventValue }),
                user_id: userId,
                partner_id: partnerId,
            });
        },
        [userId, partnerId],
    );

    return { logEvent };
};

export { useGTMPageView, useGTMEvent };
